import { gql } from '@apollo/client';

export const GET_REGISTRATION_INFO = gql`
  query getInfoForRegistration($zip: String) {
    getInfoForRegistration(zip: $zip) {
      analytic
    }
  }
`;
